export default {
    /**
     * Generate a random string.
     *
     * @param  {Number} len Desired length of the String
     * @return {String}     Random Alpha-Numeric String
     */
    generateUid: function (len) {
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var text = '';
        for (var i = 0; i < len; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    },
    /**
    * convert the role schema property name to a user friendly formatting
    * @param {String} str the DB key for the permission
    * @example
    *  helloWorld -> "Hello World"
       hello-world -> "Hello World"
       hello_world -> "Hello World" 
    */
    getHumanReadable: str => {
        if (typeof str !== "string") return str
        if (!str || str.length === 0) return str
        let readable = str[0].toUpperCase()
        for (let i = 1; i < str.length; i++) {
            if (str[i] >= 'A' & str[i] <= 'Z') {
                // is a capital letter, add a space for new word
                readable += ' ' + str[i]
            } else if (str[i] === '-' || str[i] === '_') {
                // replace dashes with a space
                readable += ' '
            } else if (str[i - 1] === '-' || str[i - 1] === '_') {
                // if last converted char was a dash
                readable += str[i].toUpperCase()
            } else {
                readable += str[i]
            }
        }
        return readable
    },
    /**
     * Convert a string to title case
     * @example "on break" => "On Break"
     * @param {String} str a string to convert to title case
     * @returns a string as title case.
     */
    toTitleCase: (str) => {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    /**
     * Removes the html tags from a string or returns the given argument if it is not a string
     * @example `<p>my <b>string</b></p><br></br>` => "my string"
     * @returns {String} 
     * @param {String} html some HTML text to remove the tags of
     */
    removeHtmlTags: (html) => {
      let doc = new DOMParser().parseFromString(html, 'text/html');
    
      return doc.body.textContent || "";
    },
};
